interface IEmptyHeader {
  id: string;
}

export const EmptyHeader = ({ id }: IEmptyHeader) => (
  <td key={id} width={id === 'eventSelector' ? '10' : ''}>
    &nbsp;
  </td>
);
